import { render } from "./employees.vue?vue&type=template&id=e3816230&scoped=true"
import script from "./employees.vue?vue&type=script&lang=js"
export * from "./employees.vue?vue&type=script&lang=js"

import "./employees.vue?vue&type=style&index=0&id=e3816230&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3816230"]])

export default __exports__